function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5173\\u95ED\\u573A\\u666F",
  transform: "translate(-32.000000, -100.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u5BFC\\u822A",
  transform: "translate(0.000000, 64.000000)"
}, React.createElement("g", {
  id: "consumption",
  transform: "translate(32.000000, 36.000000)"
}, React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "transparent",
  opacity: 0,
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M8,1 C11.8660588,1 15,4.13394117 15,8 C15,11.8660588 11.8660588,15 8,15 C4.13394117,15 1,11.8660588 1,8 C1,4.13394117 4.13394117,1 8,1 Z M8,2.23529412 C4.8162353,2.23529412 2.23529412,4.81623528 2.23529412,8 C2.23529412,11.1837647 4.81623528,13.7647059 8,13.7647059 C11.1837647,13.7647059 13.7647059,11.1837647 13.7647059,8 C13.7647059,4.81623528 11.1837647,2.23529412 8,2.23529412 Z M9.62235293,4.26941177 L10.4952941,5.14235295 L8.8737647,6.76470588 L11.0882353,6.76470588 L11.0882353,8 L8.61764706,8 L8.61764706,9.02941176 L11.0882353,9.02941176 L11.0882353,10.2647059 L8.61764706,10.2647059 L8.61764706,11.9117647 L7.38235294,11.9117647 L7.38235294,10.2647059 L4.91176471,10.2647059 L4.91176471,9.02941176 L7.38235294,9.02941176 L7.38235294,8 L4.91176471,8 L4.91176471,6.76470588 L7.12664706,6.76470588 L5.50429413,5.14235295 L6.37805883,4.26941177 L8,5.89094118 L9.62235293,4.26858823 L9.62235293,4.26941177 Z",
  id: "\\u5F62\\u72B6",
  fill: "#333333"
})))));

var SvgIconPayment = function SvgIconPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconPayment.6707ba2f.svg";
export { ForwardRef as ReactComponent };